"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selfInvitePath = exports.MA = exports.SA = void 0;
exports.SA = 'sa';
exports.MA = 'ma';
const selfInvitePath = (organizationId) => {
    return `organizations/${organizationId}/users/self-invite`;
};
exports.selfInvitePath = selfInvitePath;
//# sourceMappingURL=path.js.map